<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

</script>

<FizzStyles>
  <div
    class="fizz-layout-primary fizz-center-content fizz-inset-vertical-48"
    class:fizz-inset-square-16={$LayoutStore.isMobile}
  >
    <div
      class="fizz-card fizz-bordered fizz-inset-square-24"
      class:fizz-half-width={$LayoutStore.isDesktop}
    >
      <div class="fizz-center-content fizz-flow-16">
        <div class="fizz-surface-gray fizz-radius-round fizz-inset-square-16">
          <Icon type="Timer" fill="#002B48" height="32" width="32" />
        </div>
        <h4 class="fizz-heading-4 fizz-text-center">Your verification link has expired</h4>
        <p class="fizz-text-center">
          This link is no longer valid. To request a new email verification link, click the “Resend
          email” button on your application in Provi.
        </p>
      </div>
    </div>
  </div>
</FizzStyles>
